import { useEffect } from 'react';
import { PAGES } from 'routes/PAGES';

export const ADMIN_PANEL_BODY_CLASS = 'admin-panel-active';

export const isAdminPanelPath = (pathname) => {
    if (!pathname) return false;
    return pathname === PAGES.ADMIN
        || pathname.startsWith(`${PAGES.ADMIN}/`)
        || pathname === PAGES.NOTIFICATIONS
        || pathname.startsWith(`${PAGES.NOTIFICATIONS}/`)
        || pathname === PAGES.DASHBOARD;
};

export const useHideAdminBugReport = (pathname) => {
    useEffect(() => {
        if (!isAdminPanelPath(pathname)) return undefined;
        document.body.classList.add(ADMIN_PANEL_BODY_CLASS);
        return () => {
            document.body.classList.remove(ADMIN_PANEL_BODY_CLASS);
        };
    }, [pathname]);
};
